<template>
  <div
    id="data-list-list-view"
    class="data-list-container vs-con-loading__container">
    <vx-card>
      <template slot="no-body">
        <vs-row
          vs-w="12"
          style="position: fixed; display: block; width: 100%; height: 100%">
          <div style="position: relative; width: 100%; height: 100%">
            <span></span>
            <GmapMap
              v-if="showMap"
              ref="mapRef"
              :center="center"
              :zoom="9"
              style="width: 100%; height: 100%"
              :options="{
                zoom: 9,
                zoomControl: false,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false,
                disableDefaultUi: false,
              }">
              <GmapPolygon> </GmapPolygon>
            </GmapMap>
          </div>
        </vs-row>
      </template>
    </vx-card>

    <!--<vs-button class="mr-3 mb-2" @click="submitForm" >Get Data</vs-button>-->
  </div>
</template>

<script>
const car =
  'M17.402,0H5.643C2.526,0,0,3.467,0,6.584v34.804c0,3.116,2.526,5.644,5.643,5.644h11.759c3.116,0,5.644-2.527,5.644-5.644 V6.584C23.044,3.467,20.518,0,17.402,0z M22.057,14.188v11.665l-2.729,0.351v-4.806L22.057,14.188z M20.625,10.773 c-1.016,3.9-2.219,8.51-2.219,8.51H4.638l-2.222-8.51C2.417,10.773,11.3,7.755,20.625,10.773z M3.748,21.713v4.492l-2.73-0.349 V14.502L3.748,21.713z M1.018,37.938V27.579l2.73,0.343v8.196L1.018,37.938z M2.575,40.882l2.218-3.336h13.771l2.219,3.336H2.575z M19.328,35.805v-7.872l2.729-0.355v10.048L19.328,35.805z'
import circle from '../../assets/images/circle.png'
import circle_ijo from '../../assets/images/circle_ijo.png'
import circle_red from '../../assets/images/circle_red.png'
import * as REPO from '../../repository/index'
import { gmapApi } from 'vue2-google-maps'
import * as moment from 'moment'

export default {
  components: {},
  data() {
    return {
      disabledDates: {
        to: new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          new Date().getDay() - 14
        ), // Disable all dates up to specific date
        from: new Date(), // Disable all dates after specific date
      },
      minStart: moment().subtract(14, 'days').format('YYYY-MM-DD HH:mm'),
      maxStart: moment().format('YYYY-MM-DD HH:mm'),
      center: { lat: -6.1498619, lng: 106.882887 },
      map: '',
      circle: circle,
      markers: [],
      token: '',
      license_plate: '',
      directionsService: '',
      showMap: true,
      calculated: false,
      directionsRenderer: '',
      location_list: [
        { lat: -6.167909, lng: 106.871585 },
        { lat: -6.170949, lng: 106.865867 },
        { lat: -6.17493, lng: 106.849967 },
        { lat: -6.152307, lng: 106.874697 },
        { lat: -6.149366, lng: 106.874697 },
      ],
      dateStart: null,
      overlay: true,
      maxEnd: null,
      dateEnd: null,
      id: '',
    }
  },
  computed: {
    google: gmapApi,
  },
  watch: {},
  created() {
    var self = this
  },
  beforeDestroy() {
    // REPO.unsubscribeVehicle(this.$route.params.id);
    //
  },
  methods: {
    clear() {
      this.showMap = false
      setTimeout(() => {
        this.showMap = true
        this.$nextTick(() => {
          this.$refs.mapRef.$mapPromise.then((map) => {
            this.map = map
            self.directionsService = new google.maps.DirectionsService()
            // this.directionsRenderer = new google.maps.DirectionsRenderer;
            // this.directionsRenderer.setMap(map);
          })
        })
      }, 1000)
      this.calculated = false
    },
    loadingBtnStart(val) {
      this.$vs.loading({
        container: `.${val}`,
        scale: 0.45,
      })
    },
    loadingBtnStop(val) {
      this.$vs.loading.close(`.${val} > .con-vs-loading`)
    },
    fitMapToMarkers() {
      var markers = this.markers
      var bounds = new google.maps.LatLngBounds()
      for (var i = 0, marker; (marker = markers[i]); i++) {
        bounds.extend(marker.getPosition())
      }

      this.map.fitBounds(bounds)
    },
    drawMarkerWithoutCluster(locations) {
      var self = this
      if (this.markers.length > 0) {
        this.markers.forEach((x) => {
          x.setMap(null)
        })
      }
      this.markers = []

      locations.forEach(function (location, i) {
        //
        let loc = { lat: location.latitude, lng: location.longitude }
        let mark = new google.maps.Marker({
          position: loc,
          map: self.map,
          icon: {
            url: circle,
            anchor: new google.maps.Point(4, 4),
            scaledSize: new google.maps.Size(8, 8),
            fillColor: '#00CCBB',
            fillOpacity: 1,
            strokeColor: '',
            strokeWeight: 0,
          },
        })
        self.markers.push(mark)
      })
      this.fitMapToMarkers()
      // this.all_marker = markers;
    },
    drawPoint() {
      var self = this
      REPO.getPlayback({
        start_date: this.dateStart,
        end_date: this.dateEnd,
        license_plate: this.license_plate,
      }).then((res) => {
        let all = res.data.data
        this.drawMarkerWithoutCluster(all)
      })
    },
    viewRoute() {
      //
      var self = this
      REPO.getPlaybackWebView(
        {
          start_date: this.dateStart,
          end_date: this.dateEnd,
          license_plate: this.license_plate,
        },
        this.token
      ).then((res) => {
        self.$vs.loading.close('#data-list-list-view > .con-vs-loading')
        self.directionsService = new google.maps.DirectionsService()
        let oke = res.data.data
        var stations = oke.map((o) => {
          return { lat: o.latitude, lng: o.longitude }
        })
        //
        var lngs = stations.map(function (station) {
          return station.lng
        })
        var lats = stations.map(function (station) {
          return station.lat
        })

        this.overlay = false
        // Show stations on the map as markers
        new google.maps.Marker({
          position: stations[0],
          map: self.map,
          icon: {
            url: circle_ijo,
            anchor: new google.maps.Point(10, 10),
            scaledSize: new google.maps.Size(20, 20),
            fillColor: '#00CCBB',
            fillOpacity: 1,
            strokeColor: '',
            strokeWeight: 0,
          },
        })
        new google.maps.Marker({
          position: stations[stations.length - 1],
          map: self.map,
          icon: {
            url: circle_red,
            anchor: new google.maps.Point(10, 10),
            scaledSize: new google.maps.Size(20, 20),
            fillColor: '#00CCBB',
            fillOpacity: 1,
            strokeColor: '',
            strokeWeight: 0,
          },
        })
        for (var i = 0; i < stations.length; i++) {
          new google.maps.Marker({
            position: stations[i],
            map: self.map,
            icon: {
              url: circle,
              anchor: new google.maps.Point(5, 5),
              scaledSize: new google.maps.Size(10, 10),
              fillColor: '#00CCBB',
              fillOpacity: 1,
              strokeColor: '',
              strokeWeight: 0,
            },
            title: stations[i].license_plate,
          })
        }
        for (
          var i = 0, parts = [], max = 25 - 1;
          i < stations.length;
          i = i + max
        )
          parts.push(stations.slice(i, i + max + 1))

        // Service callback to process service results
        var service_callback = function (response, status) {
          if (status != 'OK') {
            return
          }
          var bounds = new google.maps.LatLngBounds()
          var legs = response.routes[0].legs
          for (var i = 0; i < legs.length; i++) {
            var steps = legs[i].steps
            for (var j = 0; j < steps.length; j++) {
              var nextSegment = steps[j].path
              for (var k = 0; k < nextSegment.length; k++) {
                bounds.extend(nextSegment[k])
              }
            }
          }
          self.map.fitBounds(bounds)
          var renderer = new google.maps.DirectionsRenderer()
          renderer.setMap(self.map)
          renderer.setOptions({ suppressMarkers: true, preserveViewport: true })
          renderer.setDirections(response)
        }

        // Send requests to service to get route (for stations count <= 25 only one request will be sent)
        for (var i = 0; i < parts.length; i++) {
          // Waypoints does not include first station (origin) and last station (destination)
          ;(function (i) {
            setTimeout(
              function () {
                var waypoints = []
                for (var j = 1; j < parts[i].length - 1; j++)
                  waypoints.push({ location: parts[i][j], stopover: false })
                // Service options
                var service_options = {
                  origin: parts[i][0],
                  destination: parts[i][parts[i].length - 1],
                  waypoints: waypoints,
                  travelMode: 'DRIVING',
                }
                // Send request
                self.directionsService.route(service_options, service_callback)
              },
              600 * (i + 1)
            )
          })(i)
        }
        // self.map.fitBounds({
        //     west: Math.min.apply(null, lngs),
        //     east: Math.max.apply(null, lngs),
        //     north: Math.min.apply(null, lats),
        //     south: Math.max.apply(null, lats),
        // });
        this.calculated = true
      })
    },
  },

  mounted() {
    this.$vs.loading({
      container: '#data-list-list-view',
      scale: 1,
    })
    this.license_plate = this.$route.params.license_plate
    this.dateStart = this.$route.params.start
    this.dateEnd = this.$route.params.end
    this.token = this.$route.params.token
    let self = this
    this.id = this.license_plate
    this.$refs.mapRef.$mapPromise.then((map) => {
      this.map = map
      self.directionsService = new google.maps.DirectionsService()
      // this.directionsRenderer = new google.maps.DirectionsRenderer;
      // this.directionsRenderer.setMap(map);
    })
    setTimeout(() => {
      self.viewRoute()
    }, 300)
  },
}
</script>

<style lang="scss">
.datetimepicker > .flex {
  display: none !important;
}

.visible > .flex {
  display: flex !important;
}

.date-popup > .vs-popup > .vs-popup--content {
  overflow: visible;
}
</style>

<style lang="scss" scoped>
.buletan {
  float: left;
  height: 10px;
  width: 10px;
  border-radius: 50%;
  margin-top: 3px;
  margin-right: 6px;
}

.biru {
  background: blue;
}

.merah {
  background: red;
}

.ijo {
  background: green;
}

input {
  border: 2px solid #1489da;
}

.datetimepicker > .flex {
  display: none !important;
}

.visible > .flex {
  display: flex !important;
}

.date-popup > .vs-popup > .vs-popup--content {
  overflow: visible;
}

.heights {
  width: 100%;
  height: calc(100vh - 16.5rem);
}

.legenda {
  box-shadow: -2px 2px 4px #97b5ca;
  padding: 5px;
  right: 0;
  font-size: 12px;
  width: 100px;
  position: absolute;
  z-index: 1;
  background: white;
  border-radius: 7px;
}
</style>
